import AudioFileUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AudioFileUpdateRequest";
import AudioFileBaseModel from "@models/audioFileBaseModel";
import MusicAudioTranslationViewModel from "./musicAudioTranslationViewModel";



export default class MusicAudioViewModel extends AudioFileBaseModel {
    id: string = '';
    albumId: number = 0;
    isPaid: boolean = false;
    translations: Array<MusicAudioTranslationViewModel> = [];
    constructor(obj?: Partial<MusicAudioViewModel>) {
        super();
        if (obj) {
            Object.assign(this, obj);
        }
    }
    initLanguages(langs: string[]) {
        this.translations = langs.map(x => new MusicAudioTranslationViewModel({
            langCode: x
        }))
    }
    toServerModel(): AudioFileUpdateRequest {
        return new AudioFileUpdateRequest({
            AlbumId: this.albumId,
            Base64Content: this.base64File,
            Id: this.id,
            IsPaid: this.isPaid,
            Translations: (this.translations || []).map(x=>x.toServerModel())
        })
    }
    clone(): MusicAudioViewModel {
        return new MusicAudioViewModel({
            id: this.id,
            albumId: this.albumId,
            base64File: this.base64File,
            audioUrl: this.audioUrl,
            isPaid: this.isPaid,
            translations: this.translations.map(x=>new MusicAudioTranslationViewModel({
                index: x.index,
                langCode: x.langCode,
                name: x.name
            }))
        })
    }
}